//----------------------------
// save current editable rune
//----------------------------
export default function saveCurrentEditableRune(rune) {
  // --------------
  // define object
  // --------------
  let original_rune = {
    strength: rune.strength ?? 0,
    pwr_storage: rune.pwr_storage ?? 0,
    starter: rune.starter ?? false,
    integrated: rune.integrated ?? false,
    active: rune.active ?? false,
    character_item: rune.character_item ?? null,
    notes: rune.notes ?? '',
  }
  return original_rune
}
